/**
 * Site types the API recognises. The column behind it is an unconstrained
 * string, so a value outside this list can reach the client and must not
 * invalidate the page it arrived in.
 */
export const SITE_TYPES = [
  'construction_site',
  'disposal',
  'factory',
  'plant',
  'warehouse',
] as const;
